import React from 'react';
import meetingState from '../../../../../data/constants/meetingState';
import { useI18n } from '../../../../../data/hooks/i18nHooks';

const LABELS_COMMON = {
        [meetingState.CANCELLED]: 'meeting.status.cancelled',
        [meetingState.CONFIRMED]: 'meeting.status.confirmed',
    },
    LABELS_MEETING_CREATOR = {
        [meetingState.CANCELLED]: 'meeting.status.rejected',
        [meetingState.PENDING]: 'meeting.status.waiting-for-response',
    },
    LABELS_INVITEE = {
        [meetingState.PENDING]: 'meeting.status.awaiting-your-response',
    };


function MeetingStateDescription(props) {
    const { className = '', meeting } = props,
        i18n = useI18n(),
        labels = {
            ...LABELS_COMMON,
            ...(meeting._myInvite ? LABELS_INVITEE : LABELS_MEETING_CREATOR),
        };

    return <div className={className}>{i18n[labels[meeting._state]]}</div>;
}

export default MeetingStateDescription;
